import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var VolumeX = createReactComponent("VolumeX", ["svg", defaultAttributes, [["polygon", {
  points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5",
  key: "m3abqr"
}], ["line", {
  x1: "23",
  y1: "9",
  x2: "17",
  y2: "15",
  key: "94dqui"
}], ["line", {
  x1: "17",
  y1: "9",
  x2: "23",
  y2: "15",
  key: "1er0hc"
}]]]);
export default VolumeX;